module.exports = __webpack_public_path__ + "b72ac76e9c9018c6c32262e2575abb14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/dmo.svg
// module id = 3635
// module chunks = 6